// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ef84d8cf","186":"634125b4","344":"ed8e6fcd","372":"586eeca7","377":"ec88e0a0","630":"f358fe58","841":"8827e67b","851":"56325f22","856":"accab855","858":"e50c01cc"}[chunkId] + ".chunk.js";
};